import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bienvenue, ${user.full_name}`);
      navigate(user.onboarding_completed ? "/app/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Connexion échouée");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-[#FAFAFA]">
      <div className="lg:col-span-2 bg-black text-white p-12 flex flex-col justify-between grain">
        <Link to="/" className="flex items-center gap-2" data-testid="login-logo">
          <div className="w-7 h-7 klein-bg rounded-sm flex items-center justify-center">
            <span className="font-display text-white font-bold text-sm">F</span>
          </div>
          <span className="font-display font-semibold tracking-tight">FlowMind AI</span>
        </Link>
        <div>
          <span className="overline text-zinc-400">Retour</span>
          <h2 className="font-display text-4xl font-medium tracking-tighter mt-3 mb-4">Heureux de vous revoir.</h2>
          <p className="text-zinc-400 max-w-sm">Reprenez où vous en étiez. Tous vos workflows vous attendent.</p>
        </div>
        <Link to="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors">
          <ArrowLeft size={14} /> Retour au site
        </Link>
      </div>

      <div className="lg:col-span-3 flex items-center justify-center p-8">
        <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <h1 className="font-display text-3xl font-medium tracking-tight mb-2">Connexion</h1>
            <p className="text-sm text-zinc-600">
              Pas encore de compte ? <Link to="/signup" className="klein-text hover:underline">S'inscrire</Link>
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="rounded-sm mt-2"
                placeholder="vous@entreprise.eu"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password" type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="rounded-sm mt-2"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>
          </div>

          <Button type="submit" disabled={loading} className="w-full rounded-sm bg-black text-white hover:bg-zinc-800 h-11" data-testid="login-submit-button">
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
